import {
    openWaitlistModal,
	PUB_SUB_EVENTS,
    ATTRIBUTES,
    SELECTORS
} from '@/scripts/core/global'
import {
	addItemsToCart,
	getDOMCartSectionApiIds,
	renderResponseToCartDrawer
} from '@/scripts/core/cart-functions'
import { publish } from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class QuickAddPopup extends UcoastEl {
    static override htmlSelector = 'quick-add-popup'
    selectors = {
        popup: '.quick-add-popup__content',
        overlay: '.quick-add-popup-overlay',
        form: 'form',
        options: 'input[type="radio"]',
        labels: '.quick-add-popup__label',
        variantId: 'input[name="id"]',
        toggle: '.quick-add-popup__toggle',
        preorder: '.quick-add-popup__preorder',
    }

    popup: HTMLElement
    overlay: HTMLElement
    form: HTMLFormElement
    options: NodeListOf<HTMLInputElement>
    labels: NodeListOf<HTMLLabelElement>
    variantId: HTMLInputElement
    toggle: HTMLButtonElement
    preorder: HTMLElement
    constructor() {
        super()

        this.popup = q.rs(this.selectors.popup, this)
        this.overlay = q.rs(this.selectors.overlay, document)
        this.form = q.rs(this.selectors.form, this)
        this.options = q.ol(this.selectors.options, this) as NodeListOf<HTMLInputElement>
        this.labels = q.ol(this.selectors.labels, this) as NodeListOf<HTMLLabelElement>
        this.variantId = q.rs(this.selectors.variantId, this)
        this.toggle = q.rs(this.selectors.toggle, this)
        this.preorder = q.rs(this.selectors.preorder, this)
        this.toggle.addEventListener('click', this.togglePopup.bind(this));

        this.overlay.addEventListener('click', this.closePopup.bind(this));

        this.labels.forEach(label => {
            label.addEventListener('click', this.onLabelClick.bind(this))
        })
        this.popup.addEventListener('click', (e) => e.stopPropagation())
    }

    togglePopup(e: Event) {
        e.preventDefault()
        this.overlay.append(this.popup)
        setTimeout(() => {
            this.overlay.classList.add('active')
        }, 100);
    }

    closePopup() {
        this.prepend(this.popup)
        this.overlay.classList.remove('active')
    }

    onLabelClick(e: Event) {
        e.stopPropagation()
        const target = e.currentTarget as HTMLLabelElement
        const selectedOption = target.previousElementSibling as HTMLInputElement
        if(!selectedOption) return

        const variantId = selectedOption?.dataset.variantId ?? ''
        if(!selectedOption || !variantId) return
        this.variantId.value = variantId

        const status = selectedOption.dataset.status ?? ''

        this.preorder.classList.toggle('hidden', status != 'PreOrder')

        if(status == 'OutOfStock') {
            const productTitle = q.rs('.product__title .tt-capitalize', this.popup)?.textContent?.trim()
            const productSize = selectedOption.value
            if(productTitle && productSize) {
                openWaitlistModal(parseInt(variantId), productTitle.toString(), selectedOption, productSize)
            }
            return
        }

        target.setAttribute('aria-disabled', 'true')
		target.setAttribute(ATTRIBUTES.loading, '')
        q.rs(SELECTORS.loadingOverlaySpinner, target).classList.remove('hidden')

        const formData = new FormData(this.form)
        const filteredFormData = new FormData();
        for (const [key, value] of formData.entries()) {
            if (!key.includes('--size')) {
                filteredFormData.append(key, value)
            }
        }
        if(status == 'PreOrder') filteredFormData.append('preorder', 'true')
        let formVariantId = filteredFormData.get('id')
		if (!formVariantId) throw Error('No variant id found')
		const addedVariantId = parseInt(formVariantId.toString())
        const _this = this

        addItemsToCart(filteredFormData, getDOMCartSectionApiIds())
        .then((cart) => {
            if(cart.errors) {
                console.error(cart.errors)
                return
            }


            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: addedVariantId,
            })
            renderResponseToCartDrawer(cart)
        })
        .catch((e) => {
            console.error(e)
        })
        .finally(() => {
            target.removeAttribute(ATTRIBUTES.loading)
            target.removeAttribute('aria-disabled')
            q.rs(SELECTORS.loadingOverlaySpinner, target).classList.add('hidden')
            _this.closePopup()
        })
    }
}